<div [formGroup]="form" class="form-col form-col-8">
    <mat-form-field class="mat-block">
       <input matInput [maxlength]="40"
              placeholder="Коментар до адреси (не обов’язково)"
              [formControlName]="controlName"
              autoScrollTarget>
    </mat-form-field>
</div>
